<template>
    <div class="completeusercourse">
        <div class="container-fluid">
            <div class="row vertical-align margin-top-1Point7Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 width cursor-pointer img-align-middle">
                  <a :href="downloadCSVUrl" class="text-decoration-none ">
                    <img src= "../../../assets/images/download.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="download">
                  </a>
                </div>    
                <div class="col-md-4 col-lg-4 text-align-left padding-left-2Point7Perc">
                   <a :href="downloadCSVUrl" class="text-decoration-none">
                    Download CSV Template
                   </a>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                        </div>
                    </div>
                </div><!-- end of cohort -->
            </div>
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                  Upload CSV
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="file" id="uploadcsvfile" accept=".csv">
                        </div>
                    </div>
                </div>                
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                    </div>
                  </div>
                </div>
            </div>
            <div class="row margin-bottom-2Perc margin-Top-2Point5Perc">    
              <!-- ToDo: Track this -->
              <div class="center-align">
                <button class="btn btn-primary enroll-existing-button-BG black-font-color col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1" @click="validateBeforeUpload">Upload</button>
              </div>
            </div>      
        </div>
        <csv-upload-response-overlay v-if="showUploadCSVResponseOverlay" v-bind:responseObj="getUploadCSVResponse" @showCSVResponseOverlay="hideCSVResponseOverlay"></csv-upload-response-overlay>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
        </div> 
        <loader></loader>     
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import AlertBox from '@/components/AlertOverlay'
import CSVUploadResponseOverlay from '@/components/users/complete_user_course/CSVUploadResponseOverlay'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showUploadCSVResponseOverlay: false,
      uploadCSVResponse: [],
      downloadCSVUrl: server.baseURL() + '/api/UserCohort/DownloadCompleteCourseCSVTemplate'
    }
  },
  methods: {
    hideCSVResponseOverlay (value) {
      // AK: its is used to hide the Response overlay
      this.showUploadCSVResponseOverlay = value
      // AK: enable background scrolling
      this.$store.state.isOverlayVisible = value
      // AK: Reset all filters
      document.getElementById('uploadcsvfile').value = ''
    },
    validateBeforeUpload: function () {
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      if (fileUrl !== undefined) {
        if (!this.checkCSVFileExtesion(document.getElementById('uploadcsvfile').value)) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a valid file format.'
        } else {
          this.uploadCSVTemplate()
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a .csv format.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkCSVFileExtesion: function (fileName) {
      var exts = ['.csv', '.CSV']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    uploadCSVTemplate: function () {
      var storeObj = this.$store
      var _this = this
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      const formData = new FormData()
      formData.append('CSVFile', fileUrl)
      _this.$store.state.isLoading = true
      participantService
        .completeUserCourse(
          storeObj.state.access_token,
          formData
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after recieving success response
            _this.$store.state.isLoading = false
            _this.uploadCSVResponse = responseObj.data
            // AK: Show server response to user in overlay
            _this.showUploadCSVResponseOverlay = true
            // AK: Disable background scrolling
            _this.$store.state.isOverlayVisible = true
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    }
  },
  components: {
    'alert-box': AlertBox,
    'csv-upload-response-overlay': CSVUploadResponseOverlay,
    'loader': Loader
  },
  computed: {
    getUploadCSVResponse: {
      get: function () {
        return this.uploadCSVResponse
      }
    }
  },
  watch: {},
  name: 'completeusercourse'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-2Point5Perc {
  margin-top: 2.5%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5% !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.enroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width {
  width: 95%;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.img-align-middle{
    margin-left: auto;
    margin-right: 0px;
}
.text-decoration-none {
  text-decoration: none !important;
}
.padding-left-2Point7Perc{
  padding-left:2.7%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-right{
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.margin-top-1Point7Perc {
  margin-top: 1.7%
}
.center-align {
    margin: auto;
    width: 20%;
    /* border: 3px solid green; */
    /* padding: 10px; */
}
</style>


// WEBPACK FOOTER //
// src/components/users/complete_user_course/CompleteUserCourse.vue